export default "__VITE_ASSET__s2omQOkB__"